// Notifications, push-player registration and the contact form.

import type {
  CreateMultipleNotificationsRequest,
  CreateNotificationRequest,
  RegisterPlayerRequest,
} from '../../types/notification.type';
import type { CreateContactRequest } from '../../types/contact.type';
import { ids, iso } from '../core';
import { createNotification, createNotifications, fail, listNotifications, markNotificationRead } from '../data';
import { bodyOf, ok, routes } from './helpers';

let contactCount = 0;

export const notificationRoutes = routes([
  [
    'post',
    '/notification/register-player',
    (ctx) => {
      const body = bodyOf<RegisterPlayerRequest>(ctx);
      return ok({ success: true, message: 'Player registered (demo)', player_id: String(body.player_id ?? 'demo-player') });
    },
  ],
  [
    'post',
    '/notification/unregister-player/:playerId',
    ({ params }) => ok({ success: true, message: 'Player unregistered (demo)', player_id: params.playerId }),
  ],
  [
    'post',
    '/notification/users',
    (ctx) => ok(createNotifications(bodyOf<CreateMultipleNotificationsRequest>(ctx) as CreateMultipleNotificationsRequest)),
  ],
  [
    'post',
    '/notification',
    (ctx) => {
      const body = bodyOf<CreateNotificationRequest>(ctx);
      if (!body.organization_id) fail(422, 'organization_id is required');
      return ok(createNotification(body as CreateNotificationRequest));
    },
  ],
  ['get', '/notification/:orgId', (ctx) => ok(listNotifications(ctx.params.orgId, ctx.query))],
  [
    'put',
    '/notification/:orgId/:notificationId/read',
    ({ params }) => ok(markNotificationRead(params.orgId, params.notificationId)),
  ],
  [
    'post',
    '/contact',
    (ctx) => {
      const body = bodyOf<CreateContactRequest>(ctx);
      if (!body.title || !body.message) fail(422, 'Title and message are required');
      contactCount += 1;
      return ok({
        id: ids.document(500 + contactCount),
        title: String(body.title),
        reason: body.reason ?? 'general_inquiry',
        message: String(body.message),
        created_at: iso(new Date()),
      });
    },
  ],
]);
